var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"map",staticClass:"chinaMap",staticStyle:{"width":"928px","height":"742px"},attrs:{"id":"map_cn"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }